var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"iv2-pattern__container container-fluid",class:{ 'py-0': _vm.responsive === true },domProps:{"innerHTML":_vm._s(_vm.items.content)}})}
var staticRenderFns = []

export { render, staticRenderFns }